import { render, staticRenderFns } from "./roomMeterQrcode.vue?vue&type=template&id=0bc8d994&scoped=true"
import script from "./roomMeterQrcode.vue?vue&type=script&lang=js"
export * from "./roomMeterQrcode.vue?vue&type=script&lang=js"
import style0 from "./roomMeterQrcode.vue?vue&type=style&index=0&id=0bc8d994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc8d994",
  null
  
)

export default component.exports